module.exports = __webpack_public_path__ + "static/media/speak_easy_logo_white.65b1bbc7.png";